export const MONTH_TRANSLATE = {
  '01': {
    label: 'R3015'
  },
  '02': {
    label: 'R3016'
  },
  '03': {
    label: 'R3017'
  },
  '04': {
    label: 'R3018'
  },
  '05': {
    label: 'R3019'
  },
  '06': {
    label: 'R3020'
  },
  '07': {
    label: 'R3021'
  },
  '08': {
    label: 'R3022'
  },
  '09': {
    label: 'R3023'
  },
  10: {
    label: 'R3024'
  },
  11: {
    label: 'R3025'
  },
  12: {
    label: 'R3026'
  }
};

export const FIRST_DAY_OF_WEEK = [1, 2, 3, 4, 5, 6, 7];
export const WEEK = ['C1039', 'C1040', 'C1041', 'C1042', 'C1043', 'C1044', 'C1045'];
export const SCHEDULE_ICON = {
  events: {
    1: 'label-other.svg',
    2: 'label-race.svg',
    3: 'label-test.svg'
  },
  competition: 'label-race.svg'
};
export const TRAIN_SUM = [
  {
    label: 'SQ9005',
    key: 'actualCti',
    color: '#aadb37'
  },
  {
    label: 'SQ9006',
    key: 'actualAti',
    color: '#3070ff'
  },
  {
    label: 'Y9081',
    key: 'actualTrainingLoadRatio',
    color: '#ff8602'
  }
];
export const TRAIN_SUM_DETAIL = [
  {
    label: 'R3010',
    key: 'duration',
    plan: 'plan_duration',
    act: 'act_duration'
  },
  {
    label: 'R3011',
    key: 'distance',
    plan: 'plan_distance',
    act: 'act_distance'
  },
  {
    label: 'R3009',
    key: 'trainingload',
    plan: 'plan_trainingload',
    act: 'act_trainingload'
  }
];

export const WEEK_STAGE_OPTIONS = [
  {
    label: 'C1026',
    color: 'rgba(223, 221, 40, 1)',
    bg: 'rgba(223, 221, 40, 0.2)'
  },
  {
    label: 'C1027',
    color: 'rgba(45, 227, 155, 1)',
    bg: 'rgba(45, 227, 155, 0.2)'
  },
  {
    label: 'C1028',
    color: 'rgba(2, 222, 234, 1)',
    bg: 'rgba(2, 222, 234, 0.2)'
  },
  {
    label: 'C1029',
    color: 'rgba(43, 147, 255, 1)',
    bg: 'rgba(43, 147, 255, 0.2)'
  },
  {
    label: 'C1030',
    color: 'rgba(129, 101, 255, 1)',
    bg: 'rgba(129, 101, 255, 0.2)'
  },
  {
    label: 'C1031',
    color: 'rgba(187, 187, 187, 1)',
    bg: 'rgba(187, 187, 187, 0.2)'
  }
];
export const WEEK_STAGE_OPTIONS_MAP = {
  0: {
    label: 'R3002',
    color: 'rgba(255, 255, 255, 0.6)',
    bg: '#394053'
  }
};
WEEK_STAGE_OPTIONS.forEach((item, index) => {
  WEEK_STAGE_OPTIONS_MAP[index + 1] = item;
});
export const ADD_TEMPLATE_OPTION = [
  {
    label: 'R3003',
    value: 'training',
    icon: 'iconkuaijiexunlian'
  },
  {
    label: 'R3004',
    value: 'program',
    icon: 'iconxunlianzuhe'
  },
  {
    label: 'R3005',
    value: 'label',
    icon: 'iconicon_jichutubiao_biaoqian'
  }
];

export const DEFAULT_TAG_FORM = {
  type: 2,
  name: '',
  id: '',
  planId: ''
};
export const DEFAULT_TRAINING_FORM = {
  sportType: 1,
  name: '',
  overview: '',
  id: '',
  planId: '',
  exercises: [],
  programs: {}
};
